import { useEffect } from 'react';
import { Card, CardContent, Grid, MenuItem, Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { fetchAdmin, putAdmin, toErrorMessage } from '../../admin/api';
import PermissionGate from '../../admin/components/PermissionGate';
import { AdminRouteLayout, RequestState, useAsyncState } from './AdminRoutePageShared';

export default function RiskPolicyThresholdsPage() {
  const { enqueueSnackbar } = useSnackbar();
  const thresholds = useAsyncState([]);

  useEffect(() => {
    const loadThresholds = async () => {
      thresholds.setLoading();
      try {
        const response = await fetchAdmin('/risk/third_party_thresholds');
        thresholds.setData(response.thresholds || []);
      } catch (error) {
        thresholds.setError(toErrorMessage(error));
      }
    };

    loadThresholds();
  }, []);

  const saveThreshold = (index, field, value) => {
    const updated = [...(thresholds.state.data || [])];
    updated[index] = { ...updated[index], [field]: value };
    thresholds.setData(updated);
  };

  const submitThresholds = async () => {
    try {
      await putAdmin('/risk/third_party_thresholds', {
        thresholds: (thresholds.state.data || []).map((row) => ({
          tier_code: row.tier_code,
          daily_limit: row.daily_limit,
          currency: row.currency,
          is_active: Boolean(row.is_active),
        })),
      });
      enqueueSnackbar('Thresholds updated', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(toErrorMessage(error), { variant: 'error' });
    }
  };

  return (
    <AdminRouteLayout title="Thresholds" breadcrumbTitle="Risk & Policy">
      <RequestState loading={thresholds.state.loading} error={thresholds.state.error}>
        <Card variant="outlined">
          <CardContent>
            <Stack spacing={2}>
              {(thresholds.state.data || []).map((row, index) => (
                <Grid container spacing={2} key={row.id}>
                  <Grid item xs={12} md={3}>
                    <TextField fullWidth size="small" label="Tier code" value={row.tier_code} disabled />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField fullWidth size="small" label="Daily limit" value={row.daily_limit} onChange={(event) => saveThreshold(index, 'daily_limit', event.target.value)} />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField fullWidth size="small" label="Currency" value={row.currency} onChange={(event) => saveThreshold(index, 'currency', event.target.value)} />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField select fullWidth size="small" label="Active" value={String(Boolean(row.is_active))} onChange={(event) => saveThreshold(index, 'is_active', event.target.value === 'true' ? 1 : 0)}>
                      <MenuItem value="true">true</MenuItem>
                      <MenuItem value="false">false</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
              ))}
              <PermissionGate moduleName="risk" permissionCode="risk.manage">
                <LoadingButton variant="contained" onClick={submitThresholds}>
                  Save Thresholds
                </LoadingButton>
              </PermissionGate>
            </Stack>
          </CardContent>
        </Card>
      </RequestState>
    </AdminRouteLayout>
  );
}
